@if (exportMode()) {
  <div class="flex flex-col gap-4">
    @for (chart of chartCarousel(); track $index) {
      <selectable-widget
        #sw
        [exportMode]="true"
        [selected]="isWidgetSelected(sw.nativeEl)"
        (widgetToggle)="
          widgetToggle.emit({ checked: $event, el: sw.nativeEl })
        ">
        <internal-chart
          [direction]="
            chart.type === ChartType.DOUGHNUT ? 'col-reverse' : 'col'
          "
          height="400px"
          [data]="chart"
          [currency]="displayCurrency()"
          [doughnutCenterTotal]="chart.doughnutCenterTotal"></internal-chart>
      </selectable-widget>
    }
  </div>
} @else {
  <p-carousel
    [value]="chartCarousel()"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="false"
    class="graphs-carousel">
    <ng-template let-chart #item>
      <internal-chart
        [direction]="chart.type === ChartType.DOUGHNUT ? 'col-reverse' : 'col'"
        height="400px"
        [data]="chart"
        [currency]="displayCurrency()"
        [doughnutCenterTotal]="chart.doughnutCenterTotal"></internal-chart>
    </ng-template>
  </p-carousel>
}
